import { _t } from 'utils/translation';

export const DAYS = [
  ['Monday', _t('days.monday')],
  ['Tuesday', _t('days.tuesday')],
  ['Wednesday', _t('days.wednesday')],
  ['Thursday', _t('days.thursday')],
  ['Friday', _t('days.friday')],
  ['Saturday', _t('days.saturday')],
  ['Sunday', _t('days.sunday')],
];
